import React from 'react'
import { Container, Texto, BoxLink, Link } from './Styled'

export default function TextoFinal () {

	const linkBanner = () => {
		const targetElement = document.getElementById('bannerPromocao');
		if (targetElement) {
			targetElement.scrollIntoView({
				behavior: 'smooth'
			});
		}
	}

	return (
		<Container>

			{/* Texto */}
			<Texto>Não é à toa que <strong>70% dos aprovados</strong> estudam com o Estratégia.</Texto>

			{/* Texto */}
			<Texto>Com as ferramentas da <strong>Assinatura Premium</strong>, você tem tudo para <strong>acelerar sua aprovação.</strong></Texto>

			{/* Texto */}
			<Texto>Aproveite agora <strong>até 40% OFF</strong> e seja Premium!</Texto>

			{/* Texto */}
			<Texto><strong>Atenção: essa condição especial vai sair da sua área do aluno em pouco tempo.</strong></Texto>

			{/* Texto */}
			<Texto><strong>Queremos ver o seu nome na lista de aprovados!</strong></Texto>

			{/* Box Link */}
			<BoxLink>
				<Link onClick={linkBanner}>Assine agora</Link>
			</BoxLink>

		</Container>
	)
}
